<template>
    <div class="guide-panel" :class="classObj" v-if="showHelpPanel">
        <a class="guide-collapse-btn" @click="activateGuide">
            <i :class="iconClass"></i>
        </a>
        <div class="guide-panel-content">
            <claims-guide-tiga v-if="isTiga" class="claims-guide" :tabbed="true" title="Gadget claims guide"/>
            <claims-guide v-else class="claims-guide" :tabbed="true" title="Gadget claims guide"/>
        </div>
    </div>
</template>

<script>
import claimsGuide from '../views/guide/ClaimsGuide.vue'
import claimsGuideTiga from '../views/guide/ClaimsGuideTiga.vue'

export default {
    name: 'claimGuideTab',
    components: {
        claimsGuide,
        claimsGuideTiga
    },
    data: () => ({
        showGuide: false,
        showHelpPanel: false,
        windowWidth: 0
    }),
    methods: {
        activateGuide () {
            this.showGuide = !this.showGuide;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;            
        }
    },
    computed: {
        classObj() {
            let klass = {};
            let {showGuide} = this;
            showGuide ? (klass["tab-active"] = true) : "";

            return klass;
        },
        iconClass() {
            let klass = {}
            let {showGuide} = this;
            showGuide ? (klass["fas fa-times-circle"] = true) : (klass["fas fa-info-circle"] = true)
            
            return klass
        },
        isTiga() {
            return process.env.VUE_APP_FORM_TYPE == 'tiga';
        },
    },
    watch: {
        $route: function() {
            // Check if given route is true, if it is then hide Nav. 
            if (this.$route.path.includes("makeaclaim")) {
                this.showHelpPanel = true;
                } else  {
                this.showHelpPanel = false;
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    mounted() {
        if (this.windowWidth >= 1700) {
            this.showGuide = true;
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style lang="scss" scoped>


</style>
